import { Text, Flex } from "@chakra-ui/react";

const Leader = (props) => {
    return (
        <Flex 
            flexDir="row" 
            bg="core.lg"
            width="90%" 
            minHeight={["50px", "50px", "60px", "60px", "60px", ]}
            borderRadius="10px" 
            m="6px"
            color="core.white"
            alignItems="center"
            justifyContent="space-between"
        >
            <Flex flexDir="row" alignItems="center" justifyContent="center">
                <Text 
                    fontSize={["20px","20px","20px", "28px","28px"]}
                    lineHeight="1.2"
                    ml="20px"
                    color="core.white"
                    fontWeight="800"
                >{props.id}</Text>

                <Text 
                    fontSize={["20px","20px","20px", "28px","28px"]}
                    lineHeight="1.2"
                    ml="20px"
                    color="core.white"
                    fontWeight="800"
                >{props.name}</Text>
            </Flex>


            <Flex flexDir="row" alignItems="center" justifyContent="center" mr="20px">
                <Text 
                    fontSize={["20px","20px","20px", "28px","28px"]}
                    lineHeight="1.2"
                    ml="20px"
                    color="core.red"
                    fontWeight="800"
                >{props.score} / 160</Text>
            </Flex>
           
        </Flex> 
    )
}

export default Leader;